// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"SobreNos_containerPrincipal__p3s5K"};